/**
 * results/report_notes izleyip hidden form alanlarını (results_codes,
 * details_payloads, final_notes...) senkron tutan kabuk. İş mantığının
 * tamamı saf buildInspectionPatch'tedir; buradaki tek yan etki
 * form.setFieldsValue'dur. useWatch koruması ve bağımlılık dizisi eski
 * PipeInspectionForm :56-275 davranışıyla birebirdir.
 */
import React from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import { buildInspectionPatch } from './buildInspectionPatch';

export function useInspectionResultsSync(
  form: FormInstance,
  inspectionType: string | undefined,
  weldingdataIds: Array<string | number>,
) {
  const watchedResults = (Form as any).useWatch ? (Form as any).useWatch('results', form) : undefined;
  const watchedReportNotes = (Form as any).useWatch ? (Form as any).useWatch('report_notes', form) : undefined;

  React.useEffect(() => {
    const patch = buildInspectionPatch({
      weldingdataIds,
      watchedResults,
      watchedReportNotes,
      inspectionType,
    });
    form.setFieldsValue(patch);
  }, [watchedResults, watchedReportNotes, weldingdataIds, inspectionType, form]);
}
